import { useState, useEffect } from 'react';

interface LoadingSpinnerProps {
  message?: string;
  timeout?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading...", 
  timeout = 5000 
}) => {
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTimeoutMessage(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
      <p className="text-gray-600 dark:text-gray-400 mb-2">{message}</p>
      {showTimeoutMessage && (
        <p className="text-sm text-gray-500 dark:text-gray-500">
          Taking longer than expected... Please check your connection.
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
